import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useSendPhoneVerifyCode = phone => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      userService.phoneVerifyResendCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.setQueryData(
            [QUERY_KEYS.user.phone_verify, phone],
            () => data.data,
          );
          return { success: true, data };
        }
        return { error: data?.errors?.[0] };
      }),
  });
};
